import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import {
    AppActionCreators, FileActionCreators, IApplicationState, IAppState, IListRequest, IPassMicrositeRecipientProfile, IPatientIntakeListReplacementResponse,
    IPatientIntakeListResponse, IPatientIntakeLookupDataResponse, IPatientIntakeResponse, IUpdateWorkflowDetailsRequest, RecipientActionCreators
} from '@nkr/store/index';
import { IBaseResponse, IListItem, IMedicalRecord, IPatientIntakeListItem } from '@nkr/models/index';
import { PrimaryGoalType, ProfileRecordStatus } from '@nkr/enums/index';
import { CenterGridWrapper } from './styles';
import { Button } from 'react-bootstrap';
import { IFilter, initialFilter } from './filter';
import { toast } from 'react-toastify';
import { IPatientIntakeContext, PatientIntakeProvider } from './context';
import CommonList from './common-list';
import Nav, { patientIntakeTabs, PatientIntakeTabs } from './nav';
import Drawer from 'rc-drawer';
import Details from './details';
import PatientIntakeFilter from './filters';
import ProfileCreation from './profile-creation';

interface IProps {
    centerId: number,
    tab: PatientIntakeTabs,
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    downloadFile: (docType: number, lookupId: number) => Promise<any>,
    sendResetPasswordEmail: (medicalRecordId: number) => Promise<any>,
    getQuestionaireReport: (lookupId: number) => Promise<any>,
    getPatientIntakeList: (request: IListRequest) => Promise<IPatientIntakeListResponse>,
    getPatientIntakeListReplacement: (patientScreenId: number) => Promise<IPatientIntakeListReplacementResponse>,
    getPatientIntake: (medicalRecordId: number, centerId: number) => Promise<IPatientIntakeResponse>,
    getPatientIntakeLookupData: (centerId: number) => Promise<IPatientIntakeLookupDataResponse>,
    updateWorkflowDetails: (patientScreenId: number, data: IUpdateWorkflowDetailsRequest) => Promise<IBaseResponse>,
    updateMedicalRecord: (medicalRecordId: number, data: IUpdateWorkflowDetailsRequest) => Promise<IBaseResponse>,
    uploadAboResults: (medicalRecordId: number, file: File) => Promise<any>,
    createMicrositeOrRecipient: (patientScreenId: number, data: IUpdateWorkflowDetailsRequest, profileData: IPassMicrositeRecipientProfile) => Promise<IBaseResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

const CenterList = (props: TProps) => {
    const [list, setList] = useState<IPatientIntakeListItem[]>([]);
    const [filter, setFilter] = useState<IFilter>(initialFilter);
    const [listType, setListType] = useState(1);
    const [view, setView] = useState<{ show: boolean, medicalRecordId: number, showTransfer: boolean }>({ show: false, medicalRecordId: 0, showTransfer: false });
    const [profileSetUpView, setProfileSetupView] = useState<{ show: boolean, data: IMedicalRecord, createRecipient: boolean, createMicrosite: boolean }>({ show: false, data: null, createRecipient: false, createMicrosite: false });
    const [coordinatorList, setCoordinatorList] = useState<IListItem[]>([]);
    const [referralStatusList, setReferralStatusList] = useState<IListItem[]>([]);
    const [centerList, setCenterList] = useState<IListItem[]>([]);
    const [declineReasonList, setDeclineReasonList] = useState<IListItem[]>([]);
    const [ethnicityList, setEthnicityList] = useState<IListItem[]>([]);
    const [maritalStatusList, setMaritalStatusList] = useState<IListItem[]>([]);
    const [employmentStatusList, setEmploymentStatusList] = useState<IListItem[]>([]);
    const [educationLevelList, setEducationLevelList] = useState<IListItem[]>([]);
    const [sourceList, setSourceList] = useState<string[]>([]);
    const [stateList, setStateList] = useState<IListItem[]>([]);
    const [primaryGoalList, setPrimaryGoalList] = useState<IListItem[]>([]);
    const [registrationStatusList, setRegistrationStatusList] = useState<IListItem[]>([]);
    const [profileAutomationErrors, setProfileAutomationErrors] = useState<string | null>(null);
    const container = useRef<HTMLDivElement>(null);
    const gridRef = useRef<any>(null);

    useEffect(() => {
        let listType = 0;

        switch (props.tab) {
            case PatientIntakeTabs.TO_DO: listType = 0; break;
            case PatientIntakeTabs.PENDING_ORDERS: listType = 1; break;
            case PatientIntakeTabs.PENDING_RECIPIENT_PROFILE: listType = 2; break;
            case PatientIntakeTabs.COMPLETED: listType = 3; break;
            case PatientIntakeTabs.ALL: listType = 4; break;
        }

        let newFilter = getUrlParameters();

        let parsed = qs.parse(window.location.search);
        let actionCenter = parsed.actionCenter != null ? true : false;
        let medicalRecordId = parsed.medicalRecordId != null ? parseInt(parsed.medicalRecordId) : null;

        setFilter(newFilter);

        if (actionCenter) {
            setListType(listType);
            getData(props.centerId, newFilter, listType, medicalRecordId)
        } else {
            setListType(listType);
            getData(props.centerId, newFilter, listType);
        }
    }, [props.tab]);

    const getData = (centerId: number, filter: IFilter, listType: number, medicalRecordId: number = null) => {
        let request: IListRequest = {
            centerId,
            firstName: filter.firstName,
            lastName: filter.lastName,
            email: filter.email,
            source: filter.source || '',
            birthDate: filter.dateOfBirth || '',
            registrationDateFrom: filter.registrationDateFrom || '',
            registrationDateTo: filter.registrationDateTo || '',
            listType,
            registrationStatus: filter.registrationStatus,
            referralStatus: filter.referralStatus,
            primaryGoal: filter.primaryGoal
        };

        props.showLoading('Getting patient intake list, one moment please...').then(() => {
            Promise.all([
                props.getPatientIntakeList(request),
                props.getPatientIntakeLookupData(centerId)
            ])
                .then(([listResponse, lookupResponse]) => {
                    if (listResponse.data.success && lookupResponse.data.results) {
                        let {
                            coordinatorList,
                            referralStatusList,
                            sourceList,
                            centerList,
                            declineReasonList,
                            ethnicityList,
                            maritalStatusList,
                            employmentStatusList,
                            educationLevelList,
                            stateList,
                            primaryGoalList,
                            registrationStatusList } = lookupResponse.data.results;

                        setList(listResponse.data.results);
                        setCoordinatorList(coordinatorList);
                        setReferralStatusList(referralStatusList);
                        setSourceList(sourceList || []);
                        setCenterList(centerList);
                        setDeclineReasonList(declineReasonList);
                        setEthnicityList(ethnicityList);
                        setMaritalStatusList(maritalStatusList);
                        setEmploymentStatusList(employmentStatusList);
                        setEducationLevelList(educationLevelList);
                        setStateList(stateList);
                        setPrimaryGoalList(primaryGoalList);
                        setRegistrationStatusList(registrationStatusList);

                        if (medicalRecordId != null) {
                            handleView(medicalRecordId, false);
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    toast.error('Error fetching patient intake list');
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    const refreshList = () => {
        let request: IListRequest = {
            centerId: props.centerId,
            firstName: filter.firstName,
            lastName: filter.lastName,
            email: filter.email,
            source: filter.source || '',
            birthDate: filter.dateOfBirth || '',
            registrationDateFrom: filter.registrationDateFrom || '',
            registrationDateTo: filter.registrationDateTo || '',
            listType,
            registrationStatus: filter.registrationStatus,
            referralStatus: filter.referralStatus,
            primaryGoal: filter.primaryGoal
        };

        props.showLoading('Refreshing patient intake list, one moment please...').then(() => {
            props.getPatientIntakeList(request)
                .then(response => {
                    setList(response.data.results);
                })
                .finally(() => {
                    props.hideLoading();
                })
        });
    };

    const setUrlParameters = (filter: IFilter) => {
        let paramList = [];

        if (filter.registrationDateFrom) {
            paramList.push(encodeURI('rdf=' + filter.registrationDateFrom));
        }

        if (filter.registrationDateTo) {
            paramList.push(encodeURI('rdt=' + filter.registrationDateTo));
        }

        if (filter.firstName != '') {
            paramList.push(encodeURI('fn=' + filter.firstName));
        }

        if (filter.lastName != '') {
            paramList.push(encodeURI('ln=' + filter.lastName));
        }

        if (filter.email != '') {
            paramList.push(encodeURI('email=' + filter.email));
        }

        if (filter.dateOfBirth != '') {
            paramList.push(encodeURI('dob=' + filter.dateOfBirth));
        }

        if (filter.primaryGoal) {
            paramList.push(encodeURI('pg=' + filter.primaryGoal));
        }

        if (filter.registrationStatus) {
            paramList.push(encodeURI('regst=' + filter.registrationStatus));
        }

        if (filter.referralStatus) {
            paramList.push(encodeURI('refst=' + filter.referralStatus));
        }

        if (filter.center >= 0) {
            paramList.push(encodeURI('center=' + filter.center));
        }

        if (filter.source) {
            paramList.push(encodeURI('source=' + filter.source));
        }

        let params = paramList.join('&');

        let t = patientIntakeTabs.find(x => x.key == props.tab);

        let newUrl = '/center/' + props.centerId + '/recipients/patient-intake/' + t.url + '?' + params;

        window.history.pushState({}, '', newUrl);
    }

    const getUrlParameters = () => {
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(""), { arrayFormat: 'bracket' });

        let newFilter = { ...filter };

        if (parsed.rdf) {
            newFilter.registrationDateFrom = parsed.rdf;
        }

        if (parsed.rdt) {
            newFilter.registrationDateTo = parsed.rdt;
        }

        if (parsed.fn) {
            newFilter.firstName = parsed.fn;
        }

        if (parsed.ln) {
            newFilter.lastName = parsed.ln;
        }

        if (parsed.email) {
            newFilter.email = parsed.email;
        }

        if (parsed.dob) {
            newFilter.dateOfBirth = parsed.dob;
        }

        if (parsed.pg) {
            newFilter.primaryGoal = parsed.pg;
        }

        if (parsed.regst) {
            newFilter.registrationStatus = parsed.regst;
        }

        if (parsed.refst) {
            newFilter.referralStatus = parsed.refst;
        }

        if (parsed.center) {
            newFilter.center = parseInt(parsed.center);
        }

        if (parsed.source) {
            newFilter.source = parsed.source;
        }

        return newFilter;
    }

    const handleFilterChange = (field: string, value: any) => {
        setFilter(prevFilter => ({ ...prevFilter, [field]: value }));
    };

    const handleFilterClear = () => {
        let clearedFilter: IFilter = {
            center: 0,
            source: '',
            firstName: '',
            lastName: '',
            email: '',
            dateOfBirth: '',
            registrationDateFrom: '',
            registrationDateTo: '',
            status: '',
            primaryGoal: -1
        };

        setFilter(clearedFilter);
        setUrlParameters(clearedFilter);
        getData(props.centerId, clearedFilter, listType);
    };

    const handleSearch = () => {
        setUrlParameters(filter);
        getData(props.centerId, filter, listType);
    };

    const handleExport = () => {
        if (gridRef.current && gridRef.current.getGridApi()) {
            let dateStamp = moment().format('YYYY-MM-DD_HHmm');
            let api = gridRef.current.getGridApi();

            let getGoalText = (value: number): string => {
                switch (value) {
                    case PrimaryGoalType.TransferToMicrositeCenter: return 'MS';
                    case PrimaryGoalType.TransferToKidneyForLifeCenter: return 'KFL';
                    case PrimaryGoalType.TransferToImmunoFreeCenter: return 'Immuno Free';
                    case PrimaryGoalType.StandardVoucher: return 'Standard Voucher';
                    case PrimaryGoalType.FindCenter: return 'Find Center';
                    case PrimaryGoalType.UnderstandOptions: return 'Understand Options';
                    case PrimaryGoalType.Other: return 'Other';
                    default: return '-';
                }
            };

            const params = {
                fileName: `patient_intake_list_${props.tab.toLowerCase()}_${dateStamp}.csv`,
                skipHeader: false,
                skipFooters: true,
                skipGroups: true,
                allColumns: false,
                onlySelected: false,
                columnKeys: ['rank', 'source', 'firstName', 'lastName', 'email',
                    'dateOfBirth', 'registrationDate', 'registrationStatus',
                    'referralStatus', 'coordinatorName', 'followUpDate', 'selectedGoal'],
                processCellCallback: (params: any) => {
                    // For date columns, ensure consistent MM/DD/YYYY format
                    if (params.column.colId === 'dateOfBirth'
                        || params.column.colId === 'registrationDate'
                        || params.column.colId === 'followUpDate') {
                        let date = moment(params.value);

                        return date.isValid() ? date.format('MM/DD/YYYY') : '';
                    }

                    // For primary goal, convert to text
                    if (params.column.colId === 'selectedGoal') {
                        return getGoalText(params.value);
                    }

                    return params.value;
                }
            };

            api.exportDataAsCsv(params);
        } else {
            toast.error('Unable to export data. Grid not initialized.');
        }
    };

    const handleView = (medicalRecordId: number, showTransfer: boolean) => {
        try {
            setView({ show: true, medicalRecordId, showTransfer });
        } catch (error) {
            console.error('Error loading patient details:', error);
            toast.error('Error loading patient details');
        }
    };

    const handleCancelView = () => {
        setView({ show: false, medicalRecordId: 0, showTransfer: false });
    };

    const handleSave = async (data: IMedicalRecord) => {
        let patientScreenId = data.patientScreenId;

        if (patientScreenId == 0) {
            let d = list.find(x => x.medicalRecordId);

            if (d) {
                patientScreenId = d.patientScreenId;
            }
        }

        let workflowDetails = {
            centerId: props.centerId,
            coordinatorId: data.coordinatorId,
            followUpDate: data.followUpDate,
            status: data.referralStatusId,
            firstName: data.firstName,
            lastName: data.lastName,
            preferredName: data.preferredName,
            email: data.email,
            phoneNumber: data.phoneNumber,
            phoneNumberSecondary: data.phoneNumberSecondary,
            addressLine1: data.addressLine1,
            addressLine2: data.addressLine2,
            city: data.city,
            stateProvince: data.stateProvince,
            postalCode: data.postalCode,
            addressIsUs: data.addressIsUs === 1,
            genderId: data.genderId,
            preferredLanguageId: data.preferredLanguageId,
            birthDate: data.birthDate || '',
            transferCenterId: -1,
            statusChangeCenterId: props.centerId,
            declineReason: data.declineReason != null && data.declineReason > 0 ? data.declineReason : null,
            declineReasonOther: data.declineReasonOther,
            ethnicity: data.ethnicity,
            maritalStatus: data.maritalStatus,
            employmentStatus: data.employmentStatus,
            occupation: data.occupation,
            educationLevel: data.educationLevel,
            hasHealthInsurance: data.hasHealthInsurance
        };

        try {
            await props.showLoading('Saving workflow details, one moment please...');

            const response = data.patientScreenId > 0 ?
                await props.updateWorkflowDetails(data.patientScreenId, workflowDetails)
                :
                await props.updateMedicalRecord(data.medicalRecordId, workflowDetails);

            if (response.data.success) {
                let replacementResponse = await props.getPatientIntakeListReplacement(patientScreenId);

                if (replacementResponse.data.success) {
                    let newList = _.cloneDeep(list).map(x => {
                        if (x.patientScreenId == patientScreenId) {
                            return replacementResponse.data.results
                        }

                        return x;
                    });

                    setList(newList);
                }

                toast.success('Workflow details saved successfully');
            }
        } catch (error) {
            toast.error('Unable to save the workflow details');
        } finally {
            props.hideLoading();
        }
    };

    const automateProfileCreation = async (data: IMedicalRecord, createRecipient: boolean, createMicrosite: boolean) => {
        let showProfileSetup =
            data.referralStatusId == 2
            && (data.micrositeRecordStatus == ProfileRecordStatus.NonExistent || data.recipientRecordStatus == ProfileRecordStatus.NonExistent)
            && (createMicrosite || createRecipient)

        if (showProfileSetup) {
            setView({ show: false, medicalRecordId: 0, showTransfer: false });
            setProfileSetupView({ show: true, data: data, createRecipient, createMicrosite });
        } else {
            handleSave(data);
        }
    };

    const handleCreateProfiles = async (profileData: IPassMicrositeRecipientProfile) => {
        const { data } = profileSetUpView;

        const workflowDetails = {
            centerId: props.centerId,
            coordinatorId: data.coordinatorId,
            followUpDate: data.followUpDate,
            status: data.referralStatusId,
            firstName: data.firstName,
            lastName: data.lastName,
            preferredName: data.preferredName,
            email: data.email,
            phoneNumber: data.phoneNumber,
            phoneNumberSecondary: data.phoneNumberSecondary,
            addressLine1: data.addressLine1,
            addressLine2: data.addressLine2,
            city: data.city,
            stateProvince: data.stateProvince,
            postalCode: data.postalCode,
            addressIsUs: data.addressIsUs === 1,
            genderId: data.genderId,
            preferredLanguageId: data.preferredLanguageId,
            birthDate: data.birthDate || '',
            transferCenterId: -1,
            statusChangeCenterId: props.centerId,
            declineReason: data.declineReason != null && data.declineReason > 0 ? data.declineReason : null,
            declineReasonOther: data.declineReasonOther
        };

        try {
            await props.showLoading('Saving workflow details and creating Profiles...');

            let response = await props.createMicrositeOrRecipient(data.patientScreenId, workflowDetails, profileData);

            if (response.data.success) {
                let request: IListRequest = {
                    centerId: props.centerId,
                    firstName: filter.firstName,
                    lastName: filter.lastName,
                    email: filter.email,
                    source: filter.source || '',
                    birthDate: filter.dateOfBirth || '',
                    registrationDateFrom: filter.registrationDateFrom || '',
                    registrationDateTo: filter.registrationDateTo || '',
                    listType,
                    registrationStatus: filter.registrationStatus,
                    referralStatus: filter.referralStatus,
                    primaryGoal: filter.primaryGoal
                };

                let listResponse = await props.getPatientIntakeList(request);

                setProfileSetupView({ show: false, data: null, createRecipient: false, createMicrosite: false });

                if (listResponse.data.success) {
                    setList(listResponse.data.results);
                    getData(props.centerId, filter, listType);
                }

                toast.success('Workflow details and profile creations saved successfully');
            }

            if (!response.data.success) {
                setProfileAutomationErrors(response.data.message)
            }
        } catch (error) {
            toast.error('Unable to save the workflow details');
        } finally {
            props.hideLoading();
        }
    };

    const handleCancelCreateProfiles = () => {
        setProfileSetupView({ show: false, data: null, createRecipient: false, createMicrosite: false });
    };

    let contextValue: IPatientIntakeContext = {
        isAdminView: false,
        medicalRecordId: view.medicalRecordId,
        centerId: props.centerId,
        currentTab: props.tab,
        coordinatorList,
        referralStatusList,
        centerList,
        declineReasonList,
        ethnicityList,
        maritalStatusList,
        employmentStatusList,
        educationLevelList,
        stateList,
        primaryGoalList,
        registrationStatusList,
        showTransfer: view.showTransfer,
        onView: (medicalRecordId) => handleView(medicalRecordId, false),
        onSave: automateProfileCreation,
        onDownloadFile: props.downloadFile,
        onGetQuestionaireReport: props.getQuestionaireReport,
        onPasswordResetEmail: props.sendResetPasswordEmail,
        onUploadAboResults: props.uploadAboResults,
        onCancelView: handleCancelView,
        onToggleTransfer: (medicalRecordId, show) => handleView(medicalRecordId, show),
        onRefreshList: refreshList
    };

    return (
        <PatientIntakeProvider value={contextValue}>
            <div ref={container}></div>

            <div style={{ padding: '10px 5px 20px 10px' }}>
                <Nav
                    centerId={props.centerId}
                    tab={props.tab}
                    isAdmin={false}
                />

                <div style={{ padding: 10, borderColor: '#ddd', borderStyle: 'solid', borderWidth: '0px 1px 1px 1px', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                    <PatientIntakeFilter
                        filter={filter}
                        sourceList={sourceList}
                        currentTab={props.tab}
                        onFilterChange={handleFilterChange}
                        onSearch={handleSearch}
                        onClear={handleFilterClear}
                        onExport={handleExport}
                    />

                    <CenterGridWrapper className='ag-theme-bootstrap'>
                        <CommonList
                            ref={gridRef}
                            data={list}
                            isMicrositeCenter={props.app.center != null ? props.app.center.isMicrositeParticipant : false}
                            isAdmin={false}
                        />
                    </CenterGridWrapper>
                </div>
            </div>

            <Drawer
                width='37vw'
                placement='right'
                getContainer={container.current}
                open={view.show}
            >
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Details />

                    <div className='text-center bg-info'>
                        <Button bsStyle='link' block onClick={handleCancelView}>Close This View</Button>
                    </div>
                </div>
            </Drawer>

            {profileSetUpView.show && (
                <ProfileCreation
                    show={profileSetUpView.show}
                    data={profileSetUpView.data}
                    centerId={props.centerId}
                    setupMicrosite={profileSetUpView.createMicrosite}
                    setupRecipient={profileSetUpView.createRecipient}
                    profileAutomationErrors={profileAutomationErrors}
                    onSave={handleCreateProfiles}
                    onCancel={handleCancelCreateProfiles}
                />
            )}
        </PatientIntakeProvider>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getPatientIntakeList: (request) => {
            return dispatch(RecipientActionCreators.getPatientIntakeList(false, request));
        },
        getPatientIntakeListReplacement: (patientScreenId) => {
            return dispatch(RecipientActionCreators.getPatientIntakeListReplacement(patientScreenId));
        },
        getPatientIntake: (medicalRecordId, centerId) => {
            return dispatch(RecipientActionCreators.getPatientIntake(medicalRecordId, centerId));
        },
        getPatientIntakeLookupData: (centerId) => {
            return dispatch(RecipientActionCreators.getPatientIntakeLookupData(centerId));
        },
        updateWorkflowDetails: (patientScreenId, data) => {
            return dispatch(RecipientActionCreators.updateWorkflowDetails(patientScreenId, false, data));
        },
        updateMedicalRecord: (medicalRecordId, data) => {
            return dispatch(RecipientActionCreators.updateMedicalRecord(medicalRecordId, true, data));
        },
        downloadFile: (docType, lookupId) => {
            return dispatch(FileActionCreators.downloadFile(docType, lookupId));
        },
        sendResetPasswordEmail: (medicalRecordId) => {
            return dispatch(RecipientActionCreators.sendResetPasswordEmail(medicalRecordId));
        },
        getQuestionaireReport: (lookupId) => {
            return dispatch(FileActionCreators.getQuestionaireReport(lookupId));
        },
        uploadAboResults: (medicalRecordId, file) => {
            return dispatch(FileActionCreators.uploadAboResults(medicalRecordId, file));
        },
        createMicrositeOrRecipient: (patientScreenId, data, profileData) => {
            return dispatch(RecipientActionCreators.createMicrositeOrRecipient(patientScreenId, data, profileData))
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterList);